export default "__VITE_ASSET__DWINTxiU__"